import axios from "axios";
import queryString from "query-string";
export const GETS_URL = "/Comment/Gets";
export const GET_URL = "/Comment/Get";
export const ADD_URL = "/Comment/Add";
export const CHANGE_URL = "/Comment/Change";
export const REMOVE_URL = "/Comment/Remove";
export const LIKE_URL = "/Comment/Like";
export const UNLIKE_URL = "/Comment/UnLike";

export function gets(request) {
    request.websiteId = window.$websiteId;
    // https://6200e433fdf5090017249682.mockapi.io/test/1
    // GETS_URL
    return axios.get(GETS_URL, {
        headers: {
            "Content-Type": "application/json"
        },
        params: new URLSearchParams(request)
    });
}

export function add(request) {
    request.websiteId = window.$websiteId;
    return axios.post(ADD_URL, request);
}

export function change(request) {
    request.websiteId = window.$websiteId;
    return axios.post(CHANGE_URL, request);
}

export function get(request) {
    request.websiteId = window.$websiteId;
    return axios.get(GET_URL, {
        headers: {
            "Content-Type": "application/json"
        },
        params: new URLSearchParams(request)
    });
}

export function remove(request) {
    request.websiteId = window.$websiteId;
    return axios.post(REMOVE_URL, request);
}

export function like(request) {
    request.websiteId = window.$websiteId;
    return axios.post(LIKE_URL, request);
}

export function unlike(request) {
    request.websiteId = window.$websiteId;
    return axios.post(UNLIKE_URL, request);
}
